import { type ProductType, UseCase, type VerificationType } from 'api/types';

export type OrderProductTypeInfo = {
  name: string;
  value: VerificationType;
};

export const providerProductTypeValues: OrderProductTypeInfo[] = [
  {
    name: 'Income and employment',
    value: 'income',
  },
  {
    name: 'Employment history',
    value: 'employment',
  },
  {
    name: 'Direct deposit switch',
    value: 'deposit_switch',
  },
  {
    name: 'Paycheck linked loans',
    value: 'pll',
  },
];

export const providerProductTypes = providerProductTypeValues.map((product) => product.value);

// 'transactions' is not provider product type
export const baseOrderProductTypes: OrderProductTypeInfo[] = [
  ...providerProductTypeValues,
  {
    name: 'Transactions',
    value: 'transactions',
  },
];

export const baseProductTypes = baseOrderProductTypes.map((product) => product.value);

export const additionalOrderProductTypes: OrderProductTypeInfo[] = [
  {
    name: 'Assets',
    value: 'assets',
  },
  {
    name: 'Insurance',
    value: 'insurance',
  },
];

export const BANK_INCOME_TAB = 'bank_income' as const;
export const BANK_INCOME_TAB_LABEL = 'Bank income report';

export const orderProductTypeValues: OrderProductTypeInfo[] = [
  ...baseOrderProductTypes,
  ...additionalOrderProductTypes,
];

export const orderProductTypesMap = orderProductTypeValues.reduce<Record<VerificationType, string>>(
  (acc, product) => {
    acc[product.value] = product.name;

    return acc;
  },
  {} as Record<VerificationType, string>,
);

export const PRODUCTS_WITH_MAPPING_AND_PROVIDER: ProductType[] = ['income', 'employment', 'deposit_switch', 'pll'];
export const PRODUCTS_WITH_FINANCIAL_INSTITUTION: ProductType[] = ['assets', 'transactions'];
export const PRODUCTS_WITH_ACCOUNT = ['deposit_switch', 'pll'];

// Per-use-case overrides for product labels, to match the names shown on truv.com
// landing pages. Individual and self-serve users expect to see the same product name
// in their Orders list that they picked on the landing page.
export const useCaseProductTypeLabels: Partial<Record<UseCase, Partial<Record<VerificationType, string>>>> = {
  [UseCase.MORTGAGE_LENDING]: {
    income: 'Income and employment verification',
    employment: 'Payroll-based employment verification',
    assets: 'Asset verification',
  },
  [UseCase.AUTO_LENDING]: {
    income: 'Paystub Report',
    assets: 'Banking Report',
    insurance: 'Insurance Monitoring',
  },
  [UseCase.TENANT_SCREENING]: {
    income: 'Income Verification',
    assets: 'Rental History Verification',
  },
  [UseCase.CONSUMER_LENDING]: {
    income: 'Income Verification',
    assets: 'Bank Income Verification',
  },
  [UseCase.BACKGROUND_SCREENING]: {
    employment: 'Employment History',
  },
  [UseCase.GOVERNMENT]: {
    income: 'Wage Earner Verification',
    assets: 'Self-Employment Verification',
    employment: 'Renewal Verification',
  },
};
